import { render, staticRenderFns } from "./MedalsView.vue?vue&type=template&id=627dcfa2&"
import script from "./MedalsView.vue?vue&type=script&lang=js&"
export * from "./MedalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports